import Vue from "vue";
import VueRouter from "vue-router";
import Listings from "../views/Listings.vue";

Vue.use( VueRouter );

const routes = [
    {
        path: "/",
        name: "Listings",
        component: Listings,
    }
];

const router = new VueRouter( {
    routes,
});

export default router;
